<template>
    <a-modal :visible="true" width="40vw" :footer="null" :closable="false" centered wrap-class-name="rjm-wrap" @cancel="$emit('close')">
        <div class="rjm-modal">
            <div class="rjm-head">
                <div>
                    <h3>Rejeitar requisição</h3>
                </div>
                <button class="rjm-x" @click="$emit('close')">
                    <span class="material-icons-outlined">close</span>
                </button>
            </div>

            <div class="rjm-body">
                <div class="rjm-label">Motivo</div>
                <a-textarea
                    ref="reason"
                    v-model="reason"
                    :rows="5"
                    :maxLength="1000"
                    placeholder="Ex.: Preço do arroz acima do contrato"
                />
                <div class="rjm-hint">O vendedor vê este motivo na lista de requisições dele. {{ reason.length }}/1000</div>
            </div>

            <div class="rjm-foot">
                <a-button @click="$emit('close')">Cancelar</a-button>
                <a-button type="danger" :loading="saving" :disabled="!reason.trim()" @click="reject">Rejeitar requisição</a-button>
            </div>
        </div>
    </a-modal>
</template>

<script>
import SellerOrderService from "@/services/v3/seller-orders/seller-order.service";
import visitFormat from "@/pages/visits/visit-format.mixin";
import { loaderMixin } from "@/mixins/sweet-loader.mixin";

export default {
    name: "SellerOrderRejectModal",
    mixins: [visitFormat, loaderMixin],
    props: {
        order: { type: Object, required: true },
    },
    data() {
        return {
            service: new SellerOrderService(),
            reason: "",
            saving: false,
        };
    },
    mounted() {
        this.$nextTick(() => this.$refs.reason && this.$refs.reason.focus());
    },
    methods: {
        reject() {
            this.saving = true;
            this.service
                .reject(this.order.id, this.reason.trim())
                .then(({ data }) => {
                    this.snack("Requisição rejeitada.");
                    this.$emit("rejected", data);
                    this.$emit("close");
                })
                .catch((error) => this.notifyError(error, "Não foi possível rejeitar a requisição."))
                .finally(() => {
                    this.saving = false;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.rjm-modal {
    background: #fff;
    display: flex;
    flex-direction: column;
}
.rjm-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 18px 20px 14px;

    h3 {
        font-size: 16px;
        font-weight: 600;
        color: #262626;
        margin: 0;
    }
}
.rjm-x {
    width: 28px;
    height: 28px;
    border: none;
    background: none;
    border-radius: 6px;
    color: #8c8c8c;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
        background: #f0f0f0;
        color: #262626;
    }
}
.rjm-body {
    padding: 12px 20px 16px;
    border-top: 1px solid #f0f0f0;
}
.rjm-label {
    font-size: 13px;
    color: #262626;
    margin-bottom: 6px;
}
.rjm-hint {
    font-size: 12px;
    color: #8c8c8c;
    margin-top: 6px;
}
.rjm-foot {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    padding: 14px 20px;
    border-top: 1px solid #f0f0f0;
}
</style>

<style lang="scss">
.rjm-wrap {
    .ant-modal {
        min-width: 480px;
    }

    .ant-modal-content {
        padding: 0;
        border-radius: 10px;
        overflow: hidden;
    }

    .ant-modal-body {
        padding: 0;
    }
}
</style>
